var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { HomePageWidgetTypes } from "@irati/types";
import EditImage from "./components/EditImage";
import EditVideo from "./components/EditVideo";
import EditCard from "./EditCard";
import imageIcon from "../../../images/image.svg";
import imageTextIcon from "../../../images/imageText.svg";
import videoIcon from "../../../images/video.svg";
var EditPanel = /** @class */ (function (_super) {
    __extends(EditPanel, _super);
    function EditPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleCancel = function () {
            var _a = _this.props, tempLayout = _a.tempLayout, cancelEdit = _a.cancelEdit, cancelCreate = _a.cancelCreate;
            if (tempLayout) {
                cancelEdit();
                return;
            }
            cancelCreate();
        };
        _this.handleAdd = function (widget, shape) {
            var _a = _this.props, tempLayout = _a.tempLayout, addTileToGrid = _a.addTileToGrid, editTileOnGrid = _a.editTileOnGrid;
            if (tempLayout) {
                editTileOnGrid(widget);
                return;
            }
            addTileToGrid(widget, shape);
        };
        return _this;
    }
    EditPanel.prototype.render = function () {
        var _a = this.props, createTile = _a.createTile, editingTile = _a.editingTile, tempLayout = _a.tempLayout;
        var widgetType = editingTile && editingTile.type;
        switch (widgetType) {
            case HomePageWidgetTypes.Image:
                return React.createElement(EditImage, { addTileToGrid: this.handleAdd, cancelEdit: this.handleCancel, editingTile: editingTile, hideShapeSelector: !!tempLayout });
            case HomePageWidgetTypes.ImageWithText:
                return React.createElement(EditImage, { addTileToGrid: this.handleAdd, cancelEdit: this.handleCancel, withText: true, editingTile: editingTile, hideShapeSelector: !!tempLayout });
            case HomePageWidgetTypes.Video:
                return React.createElement(EditVideo, { addTileToGrid: this.handleAdd, cancelEdit: this.handleCancel, editingTile: editingTile, hideShapeSelector: !!tempLayout });
            default:
                return (React.createElement(React.Fragment, null,
                    React.createElement(EditCard, { createTile: createTile, imageIcon: imageIcon, title: "home.feed.addTile.image.label", type: HomePageWidgetTypes.Image }),
                    React.createElement(EditCard, { createTile: createTile, imageIcon: imageTextIcon, title: "home.feed.addTile.imageAndText.label", type: HomePageWidgetTypes.ImageWithText }),
                    React.createElement(EditCard, { createTile: createTile, imageIcon: videoIcon, title: "home.feed.addTile.video.label", type: HomePageWidgetTypes.Video })));
        }
    };
    return EditPanel;
}(Component));
export default EditPanel;
